import { createClient } from '@supabase/supabase-js'
import { runtimeConfig } from '@/config/runtimeEnv'

export const supabase = createClient(
  runtimeConfig.supabaseUrl,
  runtimeConfig.supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
  },
)
